/**
 * Module reports
 * @module app.bdc.reports
 */
define([
    'angular',
    'modules/bdc/reports/controllers/bdcTabacPresseCtrl',
    'modules/bdc/reports/controllers/bdcLadditionCtrl',
    'modules/bdc/reports/controllers/bdcFleuristeCtrl',
    'modules/bdc/reports/controllers/bdcTPECtrl',
    'modules/bdc/reports/controllers/bdcScanupCtrl',
    'modules/bdc/reports/controllers/bdcFlashupCtrl',
    'modules/bdc/reports/controllers/proformaCtrl',
    'modules/bdc/reports/controllers/sepaCtrl',
    'modules/bdc/reports/controllers/sepaBuralogCtrl',
    'modules/bdc/reports/controllers/sepaLiasseNapCtrl',
    'modules/bdc/reports/controllers/mudetafCtrl',
    'modules/bdc/reports/controllers/bdcNAPCtrl',
    'modules/bdc/reports/controllers/bdcNAPOldCtrl',
    'modules/bdc/reports/controllers/bdcNAPOptionsCtrl',
    'modules/bdc/reports/controllers/bdcNAPServicesCtrl',
    'modules/bdc/reports/controllers/sepaEasyfiCtrl',
    'modules/bdc/reports/controllers/sepaSeddifCtrl',
    'modules/bdc/reports/controllers/checklistCtrl',
    'modules/bdc/reports/controllers/scannetteCtrl',
    'modules/bdc/reports/controllers/exportJDSCtrl',
    'modules/bdc/reports/controllers/exportLadditionCtrl',
    'modules/bdc/reports/controllers/exportWebTillCtrl',
    'modules/bdc/reports/controllers/simulationCtrl',
    'modules/bdc/reports/controllers/navReportCtrl',
    'modules/bdc/reports/controllers/resiliationCtrl',
    'modules/bdc/reports/factories/exportService',
    'modules/bdc/reports/factories/bdcTabacPresseService',
    'modules/bdc/reports/controllers/checklistMaterielCtrl',
    'modules/bdc/reports/controllers/bundleElectronicSignatureCtrl',
    'modules/bdc/reports/controllers/bundleNapElectronicSignatureCtrl',
    'modules/bdc/list/factories/pricesService',
    'modules/bdc/reports/controllers/modals/sendElectronicSignatureCtrl',
    'modules/bdc/reports/controllers/modals/sendPdfToMergeCgvCtrl',
    'modules/bdc/reports/controllers/eSignCtrl'
], function(angular) {

    /**
     * Configure routing
     * @param $routeProvider
     */
    function bdcReportsRouter($routeProvider) {
        $routeProvider
            .when('/reports/bdc-tabac-presse', {
                templateUrl: 'bdc/reports/partials/bdcTabacPresse.html',
                controller: 'BDCTabacPresseCtrl',
                controllerAs: 'bdcTabacPresseCtrl',
                params: {
                    menuTitle: 'BDC Principal'
                }
            })
            .when('/reports/bdc-laddition', {
                templateUrl: 'bdc/reports/partials/bdcLaddition.html',
                controller: 'BdcLadditionCtrl',
                controllerAs: 'bdcLadditionCtrl',
                params: {
                    menuTitle: "BDC L'addi+ion"
                }
            })
            .when('/reports/bdc-tpe', {
                templateUrl: 'bdc/reports/partials/bdcTPE.html',
                controller: 'BDCTPECtrl',
                controllerAs: 'bdcTPECtrl',
                params: {
                    menuTitle: 'BDC TPE'
                }
            })
            .when('/reports/bdc-scanup', {
                templateUrl: 'bdc/reports/partials/bdcScanup.html',
                controller: 'BDCScanupCtrl',
                controllerAs: 'bdcScanupCtrl',
                params: {
                    menuTitle: 'BDC SCANUP'
                }
            })
            .when('/reports/bdc-flashup', {
                templateUrl: 'bdc/reports/partials/bdcFlashup.html',
                controller: 'BDCFlashupCtrl',
                controllerAs: 'bdcFlashupCtrl',
                params: {
                    menuTitle: 'BDC FLASHUP'
                }
            })
            .when('/reports/bdc-fleuriste/:offerType', {
                templateUrl: 'bdc/reports/partials/bdcFleuriste.html',
                controller: 'BdcFleuristeCtrl',
                controllerAs: 'bdcFleuristeCtrl',
                params: {
                    menuTitle: 'BDC Fleuriste'
                }
            })
            .when('/reports/proforma', {
                templateUrl: 'bdc/reports/partials/proforma.html',
                controller: 'ProformaCtrl',
                controllerAs: 'proformaCtrl',
                params: {
                    menuTitle: 'FACTURE PROFORMA'
                }
            })
            .when('/reports/sepa/:sepaType', {
                templateUrl: 'bdc/reports/partials/sepa.html',
                controller: 'SepaCtrl',
                controllerAs: 'sepaCtrl',
                params: {
                    menuTitle: 'MANDAT SEPA'
                },
                resolve: {
                    sepaType: [
                        '$route',
                        function($route) {
                            return $route.current.params.sepaType || null;
                        }
                    ]
                }
            })
            .when('/reports/mudetaf', {
                templateUrl: 'bdc/reports/partials/mudetaf.html',
                controller: 'MudetafCtrl',
                controllerAs: 'mudetafCtrl',
                params: {
                    menuTitle: 'MUDETAF'
                }
            })
            .when('/reports/bdc-nap', {
                templateUrl: 'bdc/reports/partials/bdcNAP.html',
                controller: 'BDCNAPCtrl',
                controllerAs: 'bdcNAPCtrl',
                params: {
                    menuTitle: 'BDC CAISSE NAP'
                }
            })
            .when('/reports/bdc-nap-old', {
                templateUrl: 'bdc/reports/partials/bdcNAPOld.html',
                controller: 'BDCNAPOldCtrl',
                controllerAs: 'bdcNAPOldCtrl',
                params: {
                    menuTitle: 'BDC CAISSE NAP'
                }
            })
            .when('/reports/bdc-nap-options', {
                templateUrl: 'bdc/reports/partials/bdcNAPOptions.html',
                controller: 'BDCNAPOptionsCtrl',
                controllerAs: 'bdcNAPOptionsCtrl',
                params: {
                    menuTitle: 'BDC NAP OPTIONS'
                }
            })
            .when('/reports/bdc-nap-services', {
                templateUrl: 'bdc/reports/partials/bdcNAPServices.html',
                controller: 'BDCNAPServicesCtrl',
                controllerAs: 'bdcNAPServicesCtrl',
                params: {
                    menuTitle: 'BDC PRESTATIONS NAP'
                }
            })
            .when('/reports/proforma-nap', {
                templateUrl: 'bdc/reports/partials/proformaNAP.html',
                controller: 'ProformaCtrl',
                controllerAs: 'proformaCtrl',
                params: {
                    menuTitle: 'FACTURE PROFORMA'
                }
            })
            .when('/reports/sepa-easyfi', {
                templateUrl: 'bdc/reports/partials/sepaEasyfi.html',
                controller: 'SepaEasyfiCtrl',
                controllerAs: 'sepaEasyfiCtrl',
                params: {
                    menuTitle: 'MANDAT SEPA EASYFI'
                }
            })
            .when('/reports/sepa-seddif', {
                templateUrl: 'bdc/reports/partials/sepaSeddif.html',
                controller: 'SepaSeddifCtrl',
                controllerAs: 'sepaSeddifCtrl',
                params: {
                    menuTitle: 'MANDAT SEDDIF'
                }
            })
            .when('/reports/offre-fi', {
                templateUrl: 'bdc/reports/partials/offreFi.html',
                controller: 'ProformaCtrl',
                controllerAs: 'proformaCtrl',
                params: {
                    menuTitle: 'OFFRE FI'
                }
            })
            .when('/reports/checklist', {
                templateUrl: 'bdc/reports/partials/checklist.html',
                controller: 'ChecklistCtrl',
                controllerAs: 'checklistCtrl',
                params: {
                    menuTitle: 'CHECKLIST'
                }
            })
            .when('/reports/scannette', {
                templateUrl: 'bdc/reports/partials/scannette.html',
                controller: 'ScannetteCtrl',
                controllerAs: 'scannetteCtrl',
                params: {
                    menuTitle: 'SCANNETTE'
                }
            })
            .when('/reports/jds', {
                templateUrl: 'bdc/reports/partials/exportJDS.html',
                controller: 'ExportJDSCtrl',
                controllerAs: 'exportJDSCtrl',
                params: {
                    menuTitle: 'JDS'
                }
            })
            .when('/reports/export-laddition', {
                templateUrl: 'bdc/reports/partials/exportLaddition.html',
                controller: 'ExportLadditionCtrl',
                controllerAs: 'exportLadditionCtrl',
                params: {
                    menuTitle: "Offres L'addition"
                }
            })
            .when('/reports/export-webtill', {
                templateUrl: 'bdc/reports/partials/exportWebTill.html',
                controller: 'ExportWebTillCtrl',
                controllerAs: 'exportWebTillCtrl',
                params: {
                    menuTitle: 'Offres Caisse Web'
                }
            })
            .when('/reports/simulation', {
                templateUrl: 'bdc/reports/partials/simulation.html',
                controller: 'SimulationCtrl',
                controllerAs: 'simulationCtrl',
                params: {
                    menuTitle: 'SIMULATION'
                }
            })
            .when('/reports/resiliation', {
                templateUrl: 'bdc/reports/partials/resiliation.html',
                controller: 'ResiliationCtrl',
                controllerAs: 'resiliationCtrl',
                params: {
                    menuTitle: 'RESILIATION'
                }
            })
            .when('/reports/checklist-materiel', {
                templateUrl: 'bdc/reports/partials/checklistMateriel.html',
                controller: 'ChecklistMaterielCtrl',
                controllerAs: 'checklistMaterielCtrl',
                params: {
                    menuTitle: 'Checklist Matériel'
                }
            })
            .when('/reports/bundle-electronic-signature', {
                templateUrl: 'bdc/reports/partials/bundleElectronicSignature.html',
                controller: 'BundleElectronicSignatureCtrl',
                controllerAs: 'bundleElectronicSignatureCtrl',
                params: {
                    menuTitle: 'Bundle Electronic signature'
                }
            })
            .when('/reports/bundle-nap-electronic-signature', {
                templateUrl: 'bdc/reports/partials/bundleNapElectronicSignature.html',
                controller: 'BundleNapElectronicSignatureCtrl',
                controllerAs: 'bundleNapElectronicSignatureCtrl',
                params: {
                    menuTitle: 'Bundle Electronic signature'
                }
            })
            .when('/reports/esign/:registration', {
                templateUrl: 'bdc/reports/partials/esign.html',
                controller: 'ESignCtrl',
                controllerAs: 'eSignCtrl',
                params: {
                    menuTitle: 'Signature électronique'
                }
            });
    }

    bdcReportsRouter.$inject = ['$routeProvider'];

    angular
        .module('app.bdc.reports', [
            'app.bdc.reports.bdcTabacPresseCtrl',
            'app.bdc.reports.bdcLadditionCtrl',
            'app.bdc.reports.bdcFleuristeCtrl',
            'app.bdc.reports.bdcTPECtrl',
            'app.bdc.reports.bdcScanupCtrl',
            'app.bdc.reports.bdcFlashupCtrl',
            'app.bdc.reports.proformaCtrl',
            'app.bdc.reports.sepaCtrl',
            'app.bdc.reports.sepaBuralogCtrl',
            'app.bdc.reports.sepaLiasseNapCtrl',
            'app.bdc.reports.mudetafCtrl',
            'app.bdc.reports.bdcNAPCtrl',
            'app.bdc.reports.bdcNAPOldCtrl',
            'app.bdc.reports.bdcNAPOptionsCtrl',
            'app.bdc.reports.bdcNAPServicesCtrl',
            'app.bdc.reports.sepaEasyfiCtrl',
            'app.bdc.reports.sepaSeddifCtrl',
            'app.bdc.reports.checklistCtrl',
            'app.bdc.reports.scannetteCtrl',
            'app.bdc.reports.exportJDSCtrl',
            'app.bdc.reports.exportLadditionCtrl',
            'app.bdc.reports.exportWebTillCtrl',
            'app.bdc.reports.simulationCtrl',
            'app.bdc.reports.navReportCtrl',
            'app.bdc.reports.resiliationCtrl',
            'app.bdc.reports.exportService',
            'app.bdc.reports.bdcTabacPresseService',
            'app.bdc.reports.checklistMaterielCtrl',
            'app.bdc.reports.bundleElectronicSignatureCtrl',
            'app.bdc.reports.bundleNapElectronicSignatureCtrl',
            'app.bdc.list.pricesService',
            'app.bdc.reports.sendElectronicSignatureCtrl',
            'app.bdc.reports.sendPdfToMergeCgvCtrl',
            'app.bdc.reports.eSignCtrl'
        ])
        .config(bdcReportsRouter);
});
